// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"3f155d0b","586":"4d4fb6ae","690":"736d143e","787":"3ce4cc4d","912":"bf78bb5a"}[chunkId] + ".chunk.js";
};